import { all } from "redux-saga/effects";
import loaderSaga from "./loaderSaga";
import getAnalytics from "./analyticsSaga";
import getTranscripts from "./transcriptsSaga";
import getUser from "./userSaga";
import modalSaga from "./modalSaga";
import initateCallSaga from "./initateCallSaga.js";
export default function* rootSaga() {
  yield all([loaderSaga(), getAnalytics(), getTranscripts(), getUser(), modalSaga(),initateCallSaga()]);
}
